import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { OrganizationPanel } from "../../components/Settings/Organization/OrganizationPanel";

export const Route = createFileRoute("/settings/organization")({
	component: OrganizationRoute,
});

function OrganizationRoute() {
	const navigate = useNavigate();
	return (
		<OrganizationPanel onClose={() => navigate({ to: "/settings/account" })} />
	);
}
